import {
  Component,
  ViewChild,
  Output,
  EventEmitter,
  Input,
  OnInit,
} from "@angular/core";
import Utils from "../../../services/utils";
import { ModalComponent } from "../modal.component";
import { AuthService } from "../../../services/auth.service";

@Component({
  selector: "lowy-batch-download",
  providers: [AuthService],
  template: `
    <lowy-modal #modal>
      <div class="form">
        <div class="headline" *ngIf="!count">Batch Download Results</div>
        <div class="headline" *ngIf="count">
          Batch Download {{ count }} Results
        </div>
        <div *ngIf="canDownload && allowRawDownload" class="subheading">
          Please select how you would like to view your results to download.
          Original source files may include propreitary file types that require
          software for viewing. Results size could affect download time.
        </div>
        <div *ngIf="canDownload && allowRawDownload" class="checkboxes">
          <div class="seperator"></div>
          <span>Download:</span>
          <mat-checkbox [(ngModel)]="raw" (click)="clicked('raw')"
            >Raw data files</mat-checkbox
          >
          <mat-checkbox [(ngModel)]="list" (click)="clicked('list')"
            >List of search results</mat-checkbox
          >
          <div class="seperator"></div>
        </div>
        <div *ngIf="allowEmailDownload && raw" class="checkboxes">
          <div class="seperator"></div>
          <span
            >Receive an email when batch download is ready instead of
            waiting?</span
          >
          <mat-checkbox [(ngModel)]="emailDownloadLink">Yes</mat-checkbox>
        </div>
        <div *ngIf="!canDownload || !allowRawDownload" class="subheading">
          You are about to download a list of results. Would you like to
          continue?
        </div>
        <div class="button-row">
          <span (click)="cancel()">cancel</span>
          <span (click)="submit()" *ngIf="!emailDownloadLink">download</span>
          <span (click)="submit()" *ngIf="emailDownloadLink">email</span>
        </div>
      </div>
    </lowy-modal>
  `,
})
export class BatchDownloadModalComponent implements OnInit {
  @ViewChild("modal") modal: ModalComponent;
  @Input("allowRawDownload") allowRawDownload: boolean;
  @Input("allowEmailDownload") allowEmailDownload: boolean;
  @Input("count") count: number;

  @Output() download: EventEmitter<any>;

  public raw: boolean;
  public list: boolean;
  public emailDownloadLink: boolean;
  public canDownload: boolean;

  constructor(private authService: AuthService) {
    this.download = new EventEmitter();
  }

  async ngOnInit() {
    this.authService.permissions$.subscribe(async (permissions) => {
      this.canDownload = permissions.downloadData;
      if (!this.canDownload) {
        this.list = true;
        this.raw = false;
      }
    });
  }

  // make checkbox behave like radio
  public async clicked(type: string) {
    await Utils.sleep();
    if (type === "raw" && this.raw) {
      this.list = false;
    } else if (type === "raw" && !this.raw) {
      this.list = true;
    } else if (type === "list" && this.list) {
      this.raw = false;
    } else if (type === "list" && !this.list) {
      this.raw = true;
    }

    if (type === "list") {
      this.emailDownloadLink = false;
    }
  }

  public open() {
    this.raw = true;
    this.list = false;
    if (!this.allowRawDownload || !this.canDownload) {
      this.raw = false;
    }
    this.modal.open();
  }

  public cancel() {
    this.modal.close();
  }

  public submit() {
    if (this.raw && this.allowRawDownload) {
      this.download.emit("raw");
    } else {
      this.download.emit("list");
    }
    this.modal.close();
  }
}



// WEBPACK FOOTER //
// ./src/app/components/modal/modals/batch-download-modal.component.ts